import { defineMessages } from 'react-intl';

export const messages: {
	closeModal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ctaNoPaymentDetailsOnFile: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ctaRequestTrialText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ctaWithPaymentDetailsOnFile: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionConfluence: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionJira: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionLoom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionRovo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	existingAppsHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teamworkCollectionLoomFocusedAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	trialText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	visualAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	heading: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.heading',
		defaultMessage: 'Get Loom and the tools it works best with',
		description: 'Header text for teamwork collection crossflow modal',
	},
	closeModal: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.close',
		defaultMessage: 'Close modal',
		description: 'Label for the button to close the modal dialog',
	},
	teamworkCollectionLoomFocusedAlt: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.alt',
		defaultMessage: 'Teamwork collection illustration highlighting Loom',
		description: 'Alternative text for the teamwork collection illustration image',
	},
	ctaWithPaymentDetailsOnFile: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.ctaWithPaymentDetailsOnFile',
		defaultMessage: 'Agree and start trial',
		description: 'Confirmation button label when payment details are already on file',
	},
	ctaNoPaymentDetailsOnFile: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.ctaNoPaymentDetailsOnFile',
		defaultMessage: 'Get started',
		description: 'Confirmation button label when no payment details are on file yet',
	},
	trialText: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.trial',
		defaultMessage:
			'Teamwork Collection brings together the tools your team already uses, with Loom included.',
		description: 'Subheading when opting into a trial plan',
	},
	ctaRequestTrialText: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.cta.request.trial',
		defaultMessage: 'Request to try',
		description: 'Button text shown to non-admin users to request a trial access',
	},
	descriptionConfluence: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.description.confluence',
		defaultMessage: 'Create project docs and link them to Jira tasks',
		description: 'Description of the Confluence product and its capabilities',
	},
	descriptionJira: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.description.jira',
		defaultMessage: 'Plan and track work together in Jira',
		description: 'Description of the Jira product and its capabilities',
	},
	descriptionRovo: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.description.rovo',
		defaultMessage: 'Create AI agents to manage or organize work',
		description: 'Description of the Rovo product and its capabilities',
	},
	descriptionLoom: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.description.loom',
		defaultMessage: 'Create and attach videos to tasks to explain work',
		description: 'Description of the Loom product and its capabilities',
	},
	existingAppsHeader: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.existing.apps.header',
		defaultMessage: 'Bundled with your apps:',
		description: 'Simplified header text above the list of bundled apps',
	},
	visualAlt: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.loom.visual.alt',
		defaultMessage: 'A graphic that displays Jira, Confluence, Confluence, and Loom integrations',
		description: 'Alternate text describing the bundled apps integration graphic',
	},
});
